import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import { handleRest } from '../../h2Api'
import * as actions from '../../actions/admin/adminLocalOpportunityActions'
import { CONTACT_SUBMISSION_QUEUE } from '../../actions/localopportunities/localopportunities'

const initialState = {
  profiles: [],
  intakeForms: handleRest(),
  filters: handleRest(),
  report: handleRest(),
  selectedReportId: null,
  totalResults: 0,
  pagination: {
    current: 0,
    numPerPage: 25,
    pages: 1
  },
  filter: {
    searchTerm: '',
    includeProfileType: '',
    includeUnpublished: null,
    includeUnapproved: null
  },
  addProfileModalShown: false,
  confirmText: {},
  companyProfileFieldValues: {
    companyName: '',
    profileType: '',
    numColumns: ''
  }
}
const profileAdmin = (state = initialState, action) => {
  switch (action.type) {
    case actions.ADMIN_PROFILE_INTAKE_FORMS:
      return {
        ...state,
        intakeForms: handleRest(action)
      }
    case actions.ADMIN_FILTER_OPTIONS_LOADED:
      return {
        ...state,
        filters: handleRest(action)
      }
    case actions.TOGGLE_ADD_MODAL:
      return {
        ...state,
        addProfileModalShown: action.state
      }

    case actions.SEARCH_TERM_UPDATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.field]: action.searchTerm
        }
      }

    case actions.ADMIN_PROFILE_REPORT_LOADED:
      return {
        ...state,
        selectedReportId: action.selectedReportId,
        report: handleRest(action)
      }

    case actions.ADMIN_PROFILE_REPORT_CLEAR:
      return {
        ...state,
        report: handleRest(),
        selectedReportId: null
      }

    case actions.PROFILE_CHANGE_FIELD:
      const fieldValueMap = action.fieldValueMap

      return {
        ...state,
        confirmText: null,
        filter: { ...state.filter, ...fieldValueMap }
      }

    case actions.PROFILE_CHANGE_CREATION_FIELD:
      return {
        ...state,
        confirmText: null,
        companyProfileFieldValues: {
          ...state.companyProfileFieldValues,
          ...action.fieldValueMap
        }
      }

    case actions.PROFILE_LIST_LOAD:
      if (h2Api.isSuccess(action)) {
        return {
          ...state,
          pagination: {
            current: action.restCall.result.current,
            numPerPage: action.restCall.result.numPer,
            pages: action.restCall.result.pages
          },
          totalResults: action.restCall.result.totalResults,
          profiles: action.restCall.result.profiles
        }
      }

      return state

    default:
      return state
  }
}
const submissionDetailForm = {
  companyType: 1,
  profileId: null
}
const contactSearchForm = {
  searchTerm: ''
}
const taskDetailStatusForm = {
  statusId: -1
}
const taskDetailPlacementForm = {
  date: null,
  notes: ''
}
const adminTaskSearchForm = {
  term: '',
  type: '',
  status: ''
}
const domainForm = {
  domain: ''
}
const adminCompanyAddTypesForm = {
  types: [],
  clusters: []
}
const wblDetailForm = {}

export default combineReducers({
  wblDetailRequest: h2Api.restReducer(actions.WBL_TYPE_LOAD),
  wblDetailForm: modelReducer('admin.localOpportunities.wblDetailForm', wblDetailForm),
  createRequest: h2Api.restReducer(actions.PROFILE_CREATE),
  deleteRequest: h2Api.restReducer(actions.PROFILE_DELETE),
  approvalListingRequest: h2Api.restReducer(CONTACT_SUBMISSION_QUEUE),
  taskListRequest: h2Api.restReducer(actions.LOCAL_OPPS_TASK_QUEUE),
  taskDetailRequest: h2Api.restReducer(actions.LOCAL_OPPS_TASK_DETAIL),
  localOppsDashboardRequest: h2Api.restReducer(actions.LOCAL_OPPS_DASHBOARD),
  taskDetailPlacementForm: modelReducer(
    'admin.localOpportunities.taskDetailPlacementForm',
    contactSearchForm
  ),
  taskDetailStatusForm: modelReducer(
    'admin.localOpportunities.taskDetailStatusForm',
    taskDetailStatusForm
  ),
  taskDetailFormRequest: h2Api.restReducer(actions.LOCAL_OPPS_TASK_PLACE),
  approvalDetailRequest: h2Api.restReducer(actions.CONTACT_SUBMISSION_LOAD),
  toggleActiveRequest: h2Api.restReducer(actions.PROFILE_TOGGLE_ACTIVE),
  allContactsRequest: h2Api.restReducer(actions.ALL_CONTACTS_LOADED),
  wblFiltersRequest: h2Api.restReducer(actions.WBL_FILTER_OPTIONS_LOADED),
  contactDetailRequest: h2Api.restReducer(actions.CONTACT_DETAIL_LOADED),
  inviteUserToCompanyRequest: h2Api.restReducer(actions.ADMIN_PROFILE_CONTACT_INVITE),
  companySuggestionRequest: h2Api.restReducer(actions.COMPANY_SUGGESTIONS_RECEIVED),
  contactSubmissionSaveRequest: h2Api.restReducer(actions.CONTACT_SUBMISSION_SAVE),
  companyAddDomainRequest: h2Api.restReducer(actions.PROFILE_ADD_DOMAIN_ASSOCIATION),
  companyDeleteDomainRequest: h2Api.restReducer(
    actions.PROFILE_DELETE_DOMAIN_ASSOCIATION
  ),
  adminSubmissionDetailForm: modelReducer(
    'admin.localOpportunities.adminSubmissionDetailForm',
    submissionDetailForm
  ),
  adminSubmissionDetailRequest: h2Api.restReducer(actions.ADMIN_QUEUE_EDIT_SUBMISSION),
  adminContactSearchForm: modelReducer(
    'admin.localOpportunities.adminContactSearchForm',
    contactSearchForm
  ),
  domainForm: modelReducer('admin.localOpportunities.domainForm', domainForm),
  adminUserApplicationsRequest: h2Api.restReducer(actions.CONTACT_APPLICATION_QUEUE),
  adminTasksSearchForm: modelReducer(
    'admin.localOpportunities.adminTasksSearchForm',
    adminTaskSearchForm
  ),
  adminCompanyAddTypesForm: modelReducer(
    'admin.localOpportunities.adminCompanyAddTypesForm',
    adminCompanyAddTypesForm
  ),
  forms: formReducer('admin.localOpportunities', {
    adminSubmissionDetailForm: submissionDetailForm,
    adminContactSearchForm: contactSearchForm,
    taskDetailPlacementForm,
    adminTasksSearchForm: adminTaskSearchForm,
    adminCompanyAddTypesForm,
    taskDetailStatusForm,
    domainForm,
    wblDetailForm
  }),
  other: profileAdmin
})
